import * as fetchActions from './fetch';
import * as updateActions from './update';

export default {
  ...fetchActions,
  ...updateActions,
};
